import { Component, effect, inject } from '@angular/core';
import { LoadingService } from '@src/app/core/services/loading/loading.service';

declare var lottie: any;

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrl: './loading-overlay.component.scss',
})
export class LoadingOverlayComponent {
  private loadingService = inject(LoadingService);
  isLoading = this.loadingService.isLoading;
  animationData = {
    v: '5.7.4',
    fr: 60,
    ip: 0,
    op: 90,
    w: 128,
    h: 128,
    nm: 'spinner-16px-padding-semiring-1_5s',
    ddd: 0,
    assets: [
      {
        id: 'img_0',
        w: 32,
        h: 32,
        p: "data:image/svg+xml;utf8,<svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M14.2062 0.0235925C13.6916 0.0642078 13.4568 0.0957975 12.5765 0.226669C12.0258 0.312413 10.7573 0.632823 10.1118 0.849438C7.48002 1.74298 5.0559 3.36308 3.2412 5.43446C2.5731 6.19713 1.69734 7.4201 1.3994 8.01128C1.17369 8.45353 1.29106 8.85066 1.70186 9.02215C2.14425 9.20266 2.34287 9.06277 2.89812 8.16923C4.82116 5.07343 7.99916 2.75836 11.6015 1.82872C12.9738 1.47672 14.5628 1.30975 15.9622 1.38195C16.7161 1.41805 16.8018 1.42708 17.6956 1.56246C23.4512 2.44246 28.2318 6.90113 29.5454 12.6144C29.8885 14.1216 30.0104 15.8591 29.8704 17.2626C29.7711 18.2599 29.7395 18.4539 29.5454 19.3384C29.3287 20.3132 28.8908 21.5046 28.3762 22.538C26.6518 25.9768 23.6092 28.6213 19.9166 29.8939C19.402 30.0699 18.3276 30.3452 17.7859 30.4355C16.0886 30.7198 14.1023 30.7062 12.4818 30.3903C11.9807 30.2911 11.7911 30.2053 11.6015 29.9797C11.3397 29.6683 11.3532 30.0113 11.3532 23.9505C11.3532 20.7149 11.3351 18.3095 11.3126 18.2148C11.29 18.1245 11.2358 17.8943 11.1952 17.7003C10.9424 16.5315 10.1163 15.322 9.08256 14.609C8.41898 14.1532 7.54774 13.8102 6.77581 13.7019C6.55461 13.6704 5.33127 13.6523 3.48948 13.6523C0.198629 13.6523 0.347597 13.6388 0.121888 13.9817L4.40839e-06 14.1668V17.2355C4.40839e-06 20.593 -0.00450979 20.5163 0.27537 21.4595C0.740332 23.0164 1.77408 24.1491 3.18703 24.6681C4.03569 24.9795 4.12598 24.9885 6.37856 25.0111L8.41898 25.0336V24.3567V23.6798L6.44627 23.6617C4.5774 23.6437 4.451 23.6347 4.11244 23.5399C2.73561 23.1518 1.90951 22.2989 1.48066 20.8187L1.35878 20.399L1.34072 17.7003L1.32718 15.0016L4.04924 15.0152L6.7713 15.0287L7.23174 15.1912C7.85019 15.4078 8.35578 15.7192 8.80268 16.1569C9.40307 16.7436 9.67844 17.2265 9.9538 18.1651C10.0035 18.3276 10.0215 19.5506 10.0396 24.1446C10.0667 29.4878 10.0712 29.9345 10.1434 30.1286C10.3736 30.7378 10.7889 31.2072 11.3171 31.4554C12.2741 31.9021 15.1858 32.1368 17.0185 31.9157C18.5804 31.7261 19.8534 31.4012 21.2619 30.8371C25.2389 29.2396 28.4349 26.0535 30.0736 22.0461C30.2902 21.5227 30.4979 20.9495 30.5837 20.6246C30.6062 20.5479 30.6559 20.3764 30.6965 20.241C30.8545 19.695 30.999 18.9594 31.1299 18.0523C31.3375 16.5721 31.2563 14.1487 30.9448 12.7723C30.5566 11.0619 30.209 10.0646 29.5228 8.71077C28.2769 6.25128 26.566 4.30626 24.2954 2.75836C22.1737 1.30523 19.6774 0.398156 16.9734 0.0912847C16.2285 0.00554119 14.8652 -0.0260485 14.2062 0.0235925Z' fill='%2300A13A'/><path d='M16.7023 9.21248C15.8401 9.31627 15.023 9.54192 14.3143 9.88038C12.7795 10.6069 11.6238 11.7261 10.8519 13.2289L10.5811 13.7479L11.0189 14.2082C11.2627 14.4609 11.4929 14.7271 11.5335 14.7948L11.6148 14.9257L11.7141 14.6143C12.0527 13.5854 12.8607 12.4752 13.75 11.8028C14.4768 11.2613 15.0998 10.9544 16.0026 10.7062L16.5217 10.5618L20.5303 10.5483L24.5344 10.5347V14.3165C24.5344 18.184 24.5299 18.2201 24.3584 19.091C24.2816 19.4882 24.0785 20.0703 23.8573 20.5442C23.117 22.1191 21.8665 23.0984 20.0744 23.5136C19.5237 23.6445 18.7608 23.6715 15.8807 23.6715H12.9781V24.3485V25.0254H15.9259C17.5419 25.0254 19.1129 25.0028 19.4108 24.9803C20.9366 24.8539 22.4218 24.2447 23.4555 23.3286C24.1011 22.7509 24.5435 22.1688 24.9633 21.3474C25.2657 20.7518 25.4192 20.3456 25.5862 19.7003C25.8797 18.563 25.8887 18.378 25.8887 13.8246L25.8842 9.79463L25.7849 9.59607C25.7126 9.45166 25.6223 9.3614 25.4824 9.2892L25.2883 9.1854L21.063 9.18992C18.7382 9.19443 16.779 9.20797 16.7023 9.21248Z' fill='%2300A13A'/></svg>",
        e: 1,
      },
    ],
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: 'Spinner Semiring',
        sr: 1,
        ks: {
          o: { a: 0, k: 100 },
          r: { a: 0, k: 0 },
          p: { a: 0, k: [15, 15, 0] },
          a: { a: 0, k: [0, 0, 0] },
          s: { a: 0, k: [150, 150, 150] },
        },
        shapes: [
          {
            ty: 'gr',
            nm: 'Semiring Group',
            it: [
              {
                ty: 'el',
                p: { a: 0, k: [32, 32] },
                s: { a: 0, k: [64, 64] },
                d: 1,
                nm: 'Ellipse Path',
              },
              {
                ty: 'st',
                c: { a: 0, k: [0.69, 0.69, 0.69, 1] },
                o: { a: 0, k: 100 },
                w: { a: 0, k: 4 },
                lc: 2,
                lj: 2,
                ml: 4,
                nm: 'Stroke',
              },
              {
                ty: 'tm',
                s: {
                  a: 1,
                  k: [
                    {
                      t: 0,
                      s: [0],
                      i: { x: [0.5], y: [1] },
                      o: { x: [0.5], y: [0] },
                    },
                    {
                      t: 45,
                      s: [0],
                      i: { x: [0.5], y: [1] },
                      o: { x: [0.5], y: [0] },
                    },
                    {
                      t: 90,
                      s: [100],
                      i: { x: [0.5], y: [1] },
                      o: { x: [0.5], y: [0] },
                    },
                  ],
                },
                e: {
                  a: 1,
                  k: [
                    {
                      t: 0,
                      s: [0],
                      i: { x: [0.5], y: [1] },
                      o: { x: [0.5], y: [0] },
                    },
                    {
                      t: 45,
                      s: [100],
                      i: { x: [0.5], y: [1] },
                      o: { x: [0.5], y: [0] },
                    },
                    {
                      t: 90,
                      s: [100],
                      i: { x: [0.5], y: [1] },
                      o: { x: [0.5], y: [0] },
                    },
                  ],
                },
                o: {
                  a: 1,
                  k: [
                    {
                      t: 0,
                      s: [0],
                      i: { x: [0.5], y: [1] },
                      o: { x: [0.5], y: [0] },
                    },
                    {
                      t: 90,
                      s: [360],
                      i: { x: [0.5], y: [1] },
                      o: { x: [0.5], y: [0] },
                    },
                  ],
                },
                m: 1,
                nm: 'Trim Paths (grow then chase)',
              },
              {
                ty: 'tr',
                p: { a: 0, k: [0, 0] },
                a: { a: 0, k: [0, 0] },
                s: { a: 0, k: [100, 100] },
                r: { a: 0, k: 0 },
                o: { a: 0, k: 100 },
                sk: { a: 0, k: 0 },
                sa: { a: 0, k: 0 },
              },
            ],
          },
        ],
        ip: 0,
        op: 90,
        st: 0,
        bm: 0,
      },
      {
        ddd: 0,
        ind: 2,
        ty: 2,
        nm: 'SVG static',
        refId: 'img_0',
        sr: 1,
        ks: {
          o: { a: 0, k: 100 },
          r: { a: 0, k: 0 },
          p: { a: 0, k: [64, 64, 0] },
          a: { a: 0, k: [16, 16, 0] },
          s: { a: 0, k: [200, 200, 200] },
        },
        ip: 0,
        op: 90,
        st: 0,
        bm: 0,
      },
    ],
    markers: [],
  };

  constructor() {
    effect(() => {
      if (this.isLoading()) {
        this.loadLoadingAnimation();
      }
    });
  }

  private loadLoadingAnimation() {
    requestAnimationFrame(() => {
      // Cargar la animación
      lottie.loadAnimation({
        container: document.getElementById('eco-loading'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: this.animationData,
      });
    });
  }
}
